<template>
    <div class="position-relative tag-list-container">
        <div class="dropdown">
            <input type="text" class="form-control" placeholder="Add new" ref="tagsearch"
                   :style="{height:taglistHeight, paddingTop:taglistPadding}"
                   v-autolist.service="tagSearchOptions" @focus="calcDimens" />
        </div>
        <div class="m-1 position-absolute tag-list text-start top-0" ref="taglist">
            <span class="badge bg-primary me-1"
                  v-for="(item, index) in tags" :key="item.id">{{ itemLabel(item) }} <i @click="removeTag(index)" class="btn btn-close zoom-75"></i> </span>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import { autolist } from './autocomplete';

    var controller, timer;

    export default {
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
            options: {
                type: Array,
                default: () => []
            },
            service: {
                type: String,
                default: () => '/search'
            },
            showOnFocus: Boolean,
            showValue: {
                type: Boolean,
                default: () => true
            },
            strings: {
                type: Boolean,
                default: () => false
            },
        },
        data: function () {
            return {
                tags: [],
                tagSearchOptions: {
                    search: this.taglistSearch,
                    options: {
                        maximumItems: 10,
                        showOnFocus: this.showOnFocus,
                        showValue: this.showValue,
                        matchValue: false,
                        renderValue(v) { return `<div class="small">${v}</div>` },
                        onSelectItem: this.taglistSelected,
                        typeahead: true,
                    }
                },
                taglistHeight: '38px',
                taglistPadding: '6px',
            };
        },
        methods: {
            calcDimens() {
                let vm = this;
                const fn = () => {
                    let h = vm.$refs.taglist?.clientHeight;
                    if (isNaN(h) || !this.isVisible(vm.$refs.taglist)) {
                        setTimeout(fn, 10);
                    } else {
                        vm.taglistHeight = (h + 42) + 'px';
                        vm.taglistPadding = (h + 6) + 'px';
                    }
                };
                setTimeout(fn, 10);
            },
            isVisible(e) {
                return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            },
            itemLabel(item) {
                if (this.strings && !this.showValue) {
                    const o = this.options.find(t => t.id == item || t.value == item);
                    if (o) return o.name ?? o.label;
                }
                return item.name ?? item.label ?? item
            },
            taglistSearch(text, cb) {
                if (this.options?.length) {
                    cb(this.options);
                } else if (this.service) {
                    let query = { page: 0, size: 10, q: text.trim() };
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        if (query.q) {
                            controller?.abort();
                            controller = new AbortController();
                            axios.get(this.service, {
                                params: query,
                                signal: controller.signal,
                            }).then(result => {
                                let model = result.data.model ?? result.data;
                                if (model.rows) {
                                    cb(model.rows.map(r => { return { label: r.name ?? '', value: r.description ?? '', id: r.id, img: r.pictureUrl } }));
                                } else {
                                    Events.send(result.data.status, result.data.message);
                                }
                            }).catch(() => { });
                        }
                    }, 333);
                }
            },
            taglistSelected(item) {
                if (!this.tags.find((v) => {
                    return (v.id && item.id && v.id === item.id) || v === item || v === item.label || v === item.value;
                })) {
                    this.tags.push(this.strings ? (this.showValue ? item.value : item.label) : { id: item.id, name: item.label });
                    this.updateValue();
                }
                this.$refs.tagsearch.value = '';
                this.$refs.tagsearch.focus();
                this.calcDimens();
            },
            removeTag(idx) {
                if (idx > -1) {
                    this.tags.splice(idx, 1);
                    this.updateValue();
                }
            },
            updateValue() {
                this.$emit('update:model-value', this.tags);
                this.calcDimens();
            },
        },
        watch: {
            modelValue: {
                handler(value) {
                    if (value) this.tags = value;
                    else this.tags = [];
                },
                immediate: true,
            },
            tags: {
                handler: function (value) {
                    this.updateValue();
                },
                immediate: true
            },
        },
        mounted() {
            window.addEventListener('resize', this.calcDimens);
        },
        directives: {
            autolist
        },
        emits: ['update:model-value'],
    };
</script>
